import { useMemo, useState } from "react";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import PageHeader from "@/components/feature/PageHeader";
import FilterChips from "@/components/base/FilterChips";
import EmptyState from "@/components/base/EmptyState";
import CastCard from "@/components/feature/CastCard";
import { castItems, castCategories, castGenders } from "@/mocks/content";

export default function CastCategory() {
  useDocumentMeta({
    title: "我的朋友他的妻子 - 演员信息",
    description: "介绍影视剧中主要及配角演员资料与角色扮演。",
    keywords: "我的朋友他的妻子,演员表,演员信息,角色介绍",
    canonical: "https://w8gp.cn/category/cast",
  });

  const [category, setCategory] = useState("全部");
  const [gender, setGender] = useState("全部");

  const filtered = useMemo(
    () =>
      castItems.filter(
        (item) =>
          (category === "全部" || item.category === category) &&
          (gender === "全部" || item.gender === gender),
      ),
    [category, gender],
  );

  return (
    <>
      <PageHeader
        title="演员信息"
        subtitle="了解《我的朋友他的妻子》主要演员与角色阵容，走近每一个鲜活人物背后的表演者。"
        crumbs={[{ label: "首页", to: "/" }, { label: "演员信息" }]}
      />

      <div className="mx-auto w-full max-w-content px-4 py-8 md:px-6 md:py-12">
        <div className="mb-8 flex flex-col gap-5 rounded-lg border border-background-300 bg-background-50 p-4">
          <div className="flex flex-wrap items-center gap-3">
            <span className="shrink-0 text-sm text-foreground-500">
              <i className="ri-user-star-line mr-1"></i>
              角色类型
            </span>
            <FilterChips options={castCategories} value={category} onChange={setCategory} />
          </div>
          <div className="flex flex-wrap items-center gap-3 border-t border-background-200 pt-4">
            <span className="shrink-0 text-sm text-foreground-500">
              <i className="ri-user-line mr-1"></i>
              标签
            </span>
            <FilterChips options={castGenders} value={gender} onChange={setGender} />
          </div>
        </div>

        {filtered.length === 0 ? (
          <EmptyState message="暂无相关演员信息" icon="ri-user-search-line" />
        ) : (
          <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
            {filtered.map((item) => (
              <CastCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </>
  );
}